import { render, staticRenderFns } from "./consulter-partner.vue?vue&type=template&id=3486be80&"
import script from "./consulter-partner.vue?vue&type=script&lang=js&"
export * from "./consulter-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports